module.exports = __webpack_public_path__ + "img/stigler_left.04a4a02b.png";